import { PlanItem } from "../plan.model";
import { Tooth } from "../../../odontogram/odontogram.model";
import { TreatmentPriceConfiguration } from "../../../price/price.model";

export abstract class AbstractTreatment {
  static validate(
    item: PlanItem,
    odontogram: Tooth[],
    items: PlanItem[],
  ): boolean {
    return true;
  }

  static apply(odontogram: Tooth[], item: PlanItem): Tooth[] {
    return odontogram;
  }

  static getDescriptionIdentifiers(item: PlanItem): string[] {
    return [item.treatment];
  }

  static getIdentifier(): string {
    return null;
  }

  static getNameIdentifier(item: PlanItem): string {
    return item.treatment;
  }

  static getPriceConfiguration(): TreatmentPriceConfiguration {
    return {
      type: "simple",
      single: false,
      identifier: this.getIdentifier(),
    };
  }

  static computePrice(
    item: PlanItem,
    priceConfiguration: TreatmentPriceConfiguration,
  ): number {
    if (item.customTreatmentPrice) {
      return priceConfiguration.single
        ? item.customTreatmentPrice
        : item.customTreatmentPrice * item.teeth.length;
    }

    let price = null;

    if (priceConfiguration.type === "simple") {
      if (priceConfiguration.price) {
        price = priceConfiguration.price;
      }
    } else {
      switch (priceConfiguration.variants.identifier) {
        case "surfaces":
          price = priceConfiguration.variants.options.filter(
            (opt) => opt.value === item.options.surfaces.length,
          )[0].price;
          break;
        case "channels":
          if (item.options.channels) {
            const channelCount = parseInt(item.options.channels, 10);
            price = priceConfiguration.variants.options.filter(
              (opt) => opt.value === channelCount,
            )[0].price;
          }
          break;
        case "type":
        case "material":
          if (item.options.type) {
            price = priceConfiguration.variants.options.filter(
              (opt) => opt.value === item.options.type,
            )[0].price;
          }
          break;
        case "edentulous-rehab-type":
          const type = item.options.material + item.options.implants;
          price = priceConfiguration.variants.options.filter(
            (opt) => opt.value === type,
          )[0].price;
          break;
        default:
          price = null;
      }
    }

    if (price === null) {
      return null;
    }

    return priceConfiguration.single ? price : price * item.teeth.length;
  }

  static supports(treatment: string): boolean {
    return treatment === this.getIdentifier();
  }

  static getItemResume(item: PlanItem): any {
    return [];
  }

  static getItemList(item: PlanItem): any {
    return this.getItemResume(item);
  }

  static getTableData(item: PlanItem): any {
    return [""];
  }
}



// WEBPACK FOOTER //
// /app/src/app/core/store/plan-editor/plan/treatments/treatment.ts